export const NewCoinList = () => "/api/tvl";

export const BtcTvl = () => "/api/btctvl"

export const TVLbyToken = (id) => `/api/tvl/${id}`

export const TokenData = (id) => `/api/transactions/${id}`

export const RevenueData = () => `/api/revenue`

export const VolumeData = () => `/api/volume`

export const AverageRevenueData = () => `/api/averagerevenue`

export const AverageVolumeData = () => `/api/averagevolume`

export const TokenRevenueData = (id, days = 30) => `/api/revenue/${id}/${days}`

export const AggregateTvlData = () => `/api/historicaltvls`

export const AggregateTvlDataByDays = (days = "ITD") => `/api/historicaltvls/${days}`

export const AggregateTvlChange = (days = "ITD") => `/api/historicaltvls/change/${days}`

export const AggregateBtcTvlDataByDays = (days = "ITD") => `/api/historicalbtctvls/${days}`

export const AggregateBtcTvlChange = (days = "ITD") => `/api/historicalbtctvls/change/${days}`

export const ReservesList = () => "/api/reservesdata";

export const AggregateTtlDataByDays = (days = "ITD") => `/api/historicalttls/${days}`

export const AggregateTtlChange = (days = "ITD") => `/api/historicalttls/change/${days}`

export const KPIdata = () => `/api/kpis`